import Icon from '@ant-design/icons'
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon'
import { forwardRef } from 'react'
import { AntdCustomIconComponentProps } from '../typings/AntdCustomIconComponentProps'

const TimeCircleSvg = (props: AntdCustomIconComponentProps) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5C7.313 20.5 3.5 16.687 3.5 12ZM2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2C6.486 2 2 6.486 2 12ZM15.0473 15.5875C15.1683 15.6585 15.3003 15.6925 15.4313 15.6925C15.6863 15.6925 15.9353 15.5615 16.0763 15.3265C16.2883 14.9705 16.1713 14.5105 15.8163 14.2975L12.4113 12.2675V7.84546C12.4113 7.43146 12.0763 7.09546 11.6613 7.09546C11.2473 7.09546 10.9113 7.43146 10.9113 7.84546V12.6935C10.9113 12.9575 11.0513 13.2025 11.2773 13.3385L15.0473 15.5875Z"
    />
  </svg>
)

export const TimeCircle = forwardRef<HTMLSpanElement, AntdIconProps>(
  (props, ref) => <Icon component={TimeCircleSvg} {...props} ref={ref} />
)
